export const videoPositions = [
  { name: 'ai', x: 742, y: 24, width: 133, height: 133 },
  { name: 'trading', x: 388, y: 114, width: 128, height: 128 },
  { name: 'blockchain', x: 840, y: 114, width: 133, height: 133 },
  { name: 'innovative', x: 554, y: 265, width: 133, height: 133 },
  { name: 'frontier', x: 675, y: 355, width: 133, height: 133 },
];
